import React from "react";
import PropTypes from "prop-types";
import styled from "styled-components";
import { Col } from "react-bootstrap";

const BreadCrumbStyles = styled.div`
  display: flex;
  margin-top: 10px;
  align-items: center;
  text-overflow: ellipsis;
  min-height: 35px;
  /* // overflow: hidden; */
  .loaf {
    display: inline-block;
    .slice {
      float: left;
      // margin-top: 10px;
    }
    h1 {
      font-family: "Open Sans";
    }
    .active {
      color: ${(props) => props.theme.dark_grey};
      display: flex;
      align-items: center;
      margin: 0;
    }
    &:not(:first-child) {
      margin-left: 15px;
    }
    &:not(:last-child)::after {
      content: "\00BB";
      font-size: 30px;
      top: 5px;
      position: absolute;
      color: ${(props) => props.theme.green_g};
    }
    &:first-child {
      h1 {
        padding-left: 0;
      }
    }
  }
  @media screen and (max-width: 767px) {
    overflow: hidden;
  }
`;
const Breadcrumbs = ({ breadcrumbs, icon, xs }) => (
  <Col md={7} xs={xs}>
    <BreadCrumbStyles className="bread-aisle">
      {breadcrumbs.map((breadcrumb, idx) => {
        const activeClass = idx === breadcrumbs.length - 1 ? "active" : "";
        return (
          <div className="loaf" key={idx}>
            <div className="slice">
              <h1 className={`${activeClass} label`}>
                {breadcrumb.label} {icon}
              </h1>
            </div>
          </div>
        );
      })}
    </BreadCrumbStyles>
  </Col>
);

Breadcrumbs.propTypes = {
  breadcrumbs: PropTypes.array,
  icon: PropTypes.node,
  xs: PropTypes.number
};

export default Breadcrumbs;
